import React, { FC, useContext } from 'react';
import { StatBlockRowProps } from './index';
import { StatBlockRowStyled } from './styled';
import { Box, Icon, IconSize, Text, Theme, useMediaQuery, belowBreakpoint } from '@bechtel/gds';
import { ThemeContext } from 'styled-components';
import { StatsSpinner } from '@bechtel/client-common';

export const StatBlockRow: FC<StatBlockRowProps> = ({ value, valueText, total, icon, loading, ...rest }) => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  return (
    <StatBlockRowStyled data-testid="stat-block" {...rest}>
      <Box pb={{ sm: '100' }}>
        {!loading ? (
          <Text
            data-testid="stat-block-row-value"
            size={isWideScreen ? '700' : '800'}
            color="grey.1000"
            family="graphik"
            weight="600"
          >
            {value}
          </Text>
        ) : (
          <StatsSpinner></StatsSpinner>
        )}
        <Box pl={{ sm: '300' }} alignSelf={{ sm: 'flex-end' }}>
          {valueText && (
            <Text
              data-testid="stat-block-row-value-text"
              size={isWideScreen ? '200' : '300'}
              weight="600"
              color="grey.1000"
            >
              {valueText}
            </Text>
          )}
        </Box>
      </Box>
      <Box
        mt={{ sm: '400' }}
        py={{ sm: '100' }}
        alignItems={{ sm: 'baseline' }}
        justifyContent={{ sm: 'space-between' }}
      >
        {total &&
          (!loading ? (
            <Box pr={{ sm: '450' }}>
              <Text
                size={isWideScreen ? '700' : '800'}
                weight="600"
                color="grey.1000"
                data-testid="stat-block-row-total"
              >
                {total}
              </Text>
            </Box>
          ) : (
            <StatsSpinner></StatsSpinner>
          ))}
        {icon && (
          <Icon
            data-testid="stat-block-row-icon"
            icon={icon}
            size={isWideScreen ? IconSize.MEDIUM : IconSize.LARGE}
            fillColor="blue.800"
          />
        )}
      </Box>
    </StatBlockRowStyled>
  );
};
